import styled from "styled-components";
import { globalFont } from "../../utils/RepeatFunctions/Schedule";

export const Modal = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  top: ${(p) => (p.top ? p.top : "50px")};
  bottom: 0;
  transition: all ease 10s;
  animation: fade 0.5s linear;
  background-color: rgba(203, 209, 217, 0.5);
  display: flex;
  align-items: center !important;
  justify-content: center !important;
  width: ${(p) => p.width && p.width};
  margin: 0.05rem auto !important;

  // overflow-y: scroll;
  overflow: hidden;
  @keyframes fade {
    0% {
      opacity: 0.5;
    }
    50% {
      opacity: 0.75;
    }
    100% {
      opacity: 1;
    }
  }
`;

export const TableHead = styled.th`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const Flex = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const font1 = styled.div`
  font-family: ${globalFont};
`;
export const font2 = styled.div`
  font-family: ${globalFont};
`;

// export const Container = styled(font1)`
//   height: 591px;
//   width: 433px;
//   background-color: #fff;
//   border-color: #cbd1d9;
//   border-radius: 6px;
//   transition: opacity 0.7s linear, right 7s ease-out;
//   position: relative;
//   left: -1%;
//   right: 0;
//   top: 24px;
//   bottom: 0;
// `;

export const Container = styled(font1)`
  width: 460px;
  max-height: 88vh;
  background-color: #fff;
  border-radius: 8px;

  overflow-y: auto; /*  move scroll here */
  overflow-x: hidden;
  max-width: 100vw;
  box-sizing: border-box;
  scrollbar-width: thin;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: #cbd1d9;
    border-radius: 10px;
  }
  * {
    max-width: 100%;
    box-sizing: border-box;
  }
`;

export const ModalHead = styled(Flex)`
  width: 433px;
  height: 56px;
  margin: 0px;
  background-repeat: no-repeat;
  background-position: right 12px top 20px;

  border-bottom: 1px solid #cbd5e0;
`;
export const Iconmargin = styled.div`
  margin-right: 16px;
`;
export const ModalTitle = styled(font1)`
  color: #132047;
  font-size: 20px;
  margin: 16px;
  line-height: 24.2px;
  font-weight: 500;
`;
// export const ModalBody = styled.div`
//   height: 288px;
// `;
export const ModalBody = styled.div`
  padding-bottom: 20px;
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1;
  width: 100%;
  box-sizing: border-box;

  scrollbar-width: thin;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: #cbd1d9;
    border-radius: 10px;
  }
`;
export const ModalHeading = styled(font2)`
  font-family: ${globalFont};
  font-weight: 500;
  font-size: 14px;
  line-height: 19px;
  text-align: left;
  color: #132047;
  height: 14px;
  padding: 16px;
  margin-top: 8px;
`;
export const ModalHeadingContent = styled(Flex)`
  margin-right: 16px;
`;

export const Span = styled.span`
  margin-right: ${({ marginRight }) => marginRight && marginRight};
  font-weight: ${({ fontWeight }) => fontWeight && fontWeight};
  font-style: ${({ fontStyle }) => fontStyle && fontStyle};
  font-size: ${({ fontSize }) => fontSize && fontSize};
`;

export const ModalHeadingLeft = styled(font1)`
  margin-top: 8px;
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  width: ${(p) => (p.width ? p.width : "260px")};

  margin-left: 16px;
  text-align: left;
  color: #000000;
  height: ${(p) => (p.height ? p.height : "32px")};
  display: flex;
  align-items: flex-start;
  gap: 8px;
  flex-wrap: wrap;
`;

export const ModalHeadingRight = styled(Flex)``;

export const Button = styled.button`
  cursor: pointer;
  width: 14px;
  height: 14px;
  background-color: #557ff5;
  border: none;
  color: #f9f8f8;
  padding: 2px 2px;
  padding-bottom: 4px;
  line-height: 2px;
  margin-left: 7px;
  border-radius: 3px;
  .btnnotallowed {
    cursor: not-allowed !important;
    background-color: #cccccc;
    color: #666666;
  }
`;
export const Content = styled.table`
  margin: 16px;
  width: 401px;

  background-color: #f9f8f8;
  border-radius: 6px;
`;
export const PaynowButton = styled(Button)`
  width: 198px;
  height: 37px;
  text-align: center;
  border-radius: 6px;
  font-family: ${globalFont};
  font-weight: 600;
  font-size: 14px;
  line-height: 14px;
  margin-bottom: 30px;
`;

export const TableheadCell = styled.td`
  color: #777777;
  font-family: ${globalFont};
  font-weight: 500;
  font-size: 12px;
  line-height: 15.62px;
  // padding: 12px 16px 16px 16px;
  text-align: left;
`;
export const TableData = styled(TableheadCell)`
  //padding: 0px 16px 22px 16px;
  color: #1a1a1a;
  font-family: ${globalFont};
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
`;
export const TableheadM = styled(TableheadCell)`
  // padding: 12px 0px 16px 16px;
`;

export const TableRow = styled.tr``;
export const NumberHolder = styled.div`
  height: 16px;
  width: 22px;
  background-color: #fff;
  color: #000;
  border: #cbd1d9;
  line-height: 0%;
  margin-left: 7px;
  font-size: 11px;
  padding-top: 8px;
  border: 1px solid #f9f8f8;
`;
export const Icon = styled.div`
  width: 14px;
  height: 14px;
  cursor: pointer;
  margin-right: 16px;
`;
export const Modclosebtn = styled.button`
  width: 26px;
  height: 26px;
  border-radius: 50%;
  border: none;
  margin-left: auto;
  padding-bottom: 1px;
  line-height: 1.15px;
  margin-right: 16px;
`;

export const Errmsg = styled.p`
  color: red;
  font-size: 10px;
  line-height: 16px;
  font-weight: 400;
  width: 110%;
`;

export const Tablecontainer = styled.div`
  background: ${(p) => p.background && p.background};
`;

export const Display = styled.div`
  display: ${(p) => p.display && p.display};
`;

export const ModalInfoText = styled(font1)`
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  color: #000000;
  margin: 10px 16px 6px 16px;
  text-align: left;
  background-color: #f5f5f5;
  border-radius: 6px;
  padding: 10px 12px;
`;

// changes
export const PlanBadge = styled.span`
  font-family: ${globalFont};
  font-size: 12px;
  font-weight: 500;
  color: #2c7be5;
  background-color: #e8f0fe;
  border-radius: 12px;
  padding: 4px 12px;
  display: inline-block;
`;

export const WarningBox = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background-color: #fffbeb;
  border: 1px solid #f59e0b;
  border-radius: 6px;
  padding: 12px 14px;
  margin: 0 16px 12px 16px;
  font-family: ${globalFont};
  font-size: 13px;
  font-weight: 400;
  color: #92400e;
  line-height: 1.5;
  text-align: left;
`;
export const ErrorBox = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  background-color: #fff2f2;
  border: 1px solid #f5c6cb;
  border-radius: 6px;
  padding: 10px 12px;
  margin: 0 16px 12px 16px;
  font-size: 12px;
  color: #721c24;
  line-height: 1.5;
  text-align: left;

  span {
    flex-shrink: 0;
    margin-top: 1px;
  }
`;

/* ── Custom Checkbox ── */
export const CustomCheckbox = styled.div`
  width: 16px;
  height: 16px;
  min-width: 16px;
  flex-shrink: 0;
  margin-top: 2px;
  border-radius: 4px;
  border: 1.5px solid ${(props) => (props.checked ? "#2563EB" : "#D1D5DB")};
  background-color: ${(props) => (props.checked ? "#2563EB" : "#ffffff")};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;

  &::after {
    content: "";
    display: ${(props) => (props.checked ? "block" : "none")};
    width: 4px;
    height: 8px;
    border: 2px solid #ffffff;
    border-top: none;
    border-left: none;
    transform: rotate(45deg) translateY(-1px);
  }
`;

/* ── e-Prescription type rows ── */
export const EPrescTypeRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 16px 5px 16px;
  margin-left: 25px;
`;

export const EPrescTypeLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: ${(p) => (p.disabled ? "#9CA3AF" : "#1a1a1a")};
  font-family: ${globalFont};
`;

export const EPrescCounterWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const SmallCountBtn = styled.button`
  width: 16px;
  height: 16px;
  border-radius: 3px;
  border: none;
  background-color: ${(p) => (p.disabled ? "#E5E7EB" : "#557ff5")};
  color: ${(p) => (p.disabled ? "#9CA3AF" : "#fff")};
  font-size: 13px;
  line-height: 1;
  cursor: ${(p) => (p.disabled ? "not-allowed" : "pointer")};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0 1px 0;
`;

export const SmallNumberHolder = styled.div`
  width: 24px;
  height: 16px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 3px;
  font-size: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000;
  font-family: ${globalFont};
`;

/* ── Figma-style Table ── */
export const FigmaTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-family: ${globalFont};
  background: #ffffff;
`;

export const FigmaTH = styled.th`
  font-size: 12px;
  font-weight: 600;
  color: #374151;
  text-align: left;
  padding: 10px 16px;
  background: #f3f4f6;
  border-bottom: 1px solid #e5e7eb;
  &:not(:first-child) {
    text-align: right;
  }
`;

export const FigmaTD = styled.td`
  font-size: 13px;
  font-weight: 400;
  color: #1a1a1a;
  padding: 10px 16px;
  border-bottom: 1px solid #e5e7eb;
  text-align: left;
  vertical-align: middle;
  background: #ffffff;
  &:not(:first-child) {
    text-align: right;
  }
`;

export const FigmaTotalTD = styled.td`
  font-size: 13px;
  font-weight: 700;
  color: #111827;
  padding: 10px 16px;
  border-top: 1px solid #e5e7eb;
  border-bottom: none;
  text-align: left;
  vertical-align: middle;
  background: #ffffff;
  &:not(:first-child) {
    text-align: right;
  }
`;
